import { render, staticRenderFns } from "./selectionInquiryCreate.vue?vue&type=template&id=6e979ad6&scoped=true"
import script from "./selectionInquiryCreate.vue?vue&type=script&lang=js"
export * from "./selectionInquiryCreate.vue?vue&type=script&lang=js"
import style0 from "./selectionInquiryCreate.vue?vue&type=style&index=0&id=6e979ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e979ad6",
  null
  
)

export default component.exports